import React, { useState, useMemo } from "react";
import TopNavigation from "components/ui/TopNavigation";
import QuickActionToolbar from "components/ui/QuickActionToolbar";
import NotificationAlertBar from "components/ui/NotificationAlertBar";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";
import Input from "components/ui/Input";
import ProductCard from "./components/ProductCard";
import CartPanel from "./components/CartPanel";
import OrderForm from "./components/OrderForm";
import OrderTracker from "./components/OrderTracker";
import UploadOrderModal from "./components/UploadOrderModal";
import OrderSuccessModal from "./components/OrderSuccessModal";
import InventorySyncBar from "./components/InventorySyncBar";

const PRODUCTS = [
{ id: "p001", name: "Shampoo 400ml (Case of 12)", sku: "SKU-SH01", category: "Hair Care", price: 1440.00, promoPrice: null, stock: 145, unit: "case", image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d6751858-1772830968210.png", imageAlt: "Shampoo bottles in a case arranged neatly on warehouse shelf" },
{ id: "p002", name: "Conditioner 400ml (Case of 12)", sku: "SKU-CO01", category: "Hair Care", price: 1560.00, promoPrice: 1404.00, stock: 88, unit: "case", image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c409e709-1772830968826.png", imageAlt: "Conditioner bottles arranged in cardboard case on distribution shelf" },
{ id: "p003", name: "Soap Bar 135g (Case of 24)", sku: "SKU-SB01", category: "Body Care", price: 720.00, promoPrice: null, stock: 320, unit: "case", image: "https://images.unsplash.com/photo-1651423128357-84a40c824ce9", imageAlt: "White bar soap stacked in organized rows on store shelf" },
{ id: "p004", name: "Body Wash 500ml (Case of 12)", sku: "SKU-BW01", category: "Body Care", price: 1680.00, promoPrice: 1512.00, stock: 7, unit: "case", image: "https://img.rocket.new/generatedImages/rocket_gen_img_180e7860d-1772830966087.png", imageAlt: "Body wash bottles in various scents stacked in warehouse storage" },
{ id: "p005", name: "Toothpaste 150g (Case of 24)", sku: "SKU-TP01", category: "Oral Care", price: 1200.00, promoPrice: null, stock: 0, unit: "case", image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c1a9abf1-1772830960771.png", imageAlt: "Toothpaste tubes in white and blue packaging on warehouse pallet" },
{ id: "p006", name: "Mouthwash 500ml (Case of 12)", sku: "SKU-MW01", category: "Oral Care", price: 1920.00, promoPrice: null, stock: 54, unit: "case", image: "https://img.rocket.new/generatedImages/rocket_gen_img_162244133-1772830961192.png", imageAlt: "Mouthwash bottles in mint green packaging on distribution shelf" },
{ id: "p007", name: "Facial Wash 100ml (Case of 24)", sku: "SKU-FW01", category: "Skin Care", price: 2160.00, promoPrice: 1944.00, stock: 112, unit: "case", image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d57da770-1772830962951.png", imageAlt: "Facial wash tubes in clean white packaging stacked in grocery warehouse" },
{ id: "p008", name: "Lotion 200ml (Case of 12)", sku: "SKU-LT01", category: "Skin Care", price: 1800.00, promoPrice: null, stock: 39, unit: "case", image: "https://img.rocket.new/generatedImages/rocket_gen_img_190631472-1772830960555.png", imageAlt: "Lotion bottles in pastel packaging on distribution warehouse shelf" },
{ id: "p009", name: "Deodorant Roll-on 50ml (Case of 24)", sku: "SKU-DO01", category: "Body Care", price: 1440.00, promoPrice: null, stock: 67, unit: "case", image: "https://img.rocket.new/generatedImages/rocket_gen_img_100042e9d-1772830966849.png", imageAlt: "Deodorant roll-on bottles in white case on warehouse floor" },
{ id: "p010", name: "Dishwashing Liquid 500ml (Case of 12)", sku: "SKU-DL01", category: "Household Care", price: 960.00, promoPrice: 864.00, stock: 200, unit: "case", image: "https://img.rocket.new/generatedImages/rocket_gen_img_19e7915ef-1772204134704.png", imageAlt: "Dishwashing liquid bottles in yellow and green on supermarket shelf" },
{ id: "p011", name: "Shampoo 200ml Travel (Case of 24)", sku: "SKU-SH02", category: "Hair Care", price: 1080.00, promoPrice: null, stock: 23, unit: "case", image: "https://img.rocket.new/generatedImages/rocket_gen_img_1171a9e25-1772830967903.png", imageAlt: "Travel-size shampoo bottles in small cardboard case on warehouse pallet" },
{ id: "p012", name: "Body Wash 250ml Travel (Case of 24)", sku: "SKU-BW02", category: "Body Care", price: 1320.00, promoPrice: null, stock: 45, unit: "case", image: "https://img.rocket.new/generatedImages/rocket_gen_img_13bd80c9e-1772830963184.png", imageAlt: "Travel body wash bottles in compact packaging stacked in distribution warehouse" }];


const RECENT_ORDERS = [
{ id: "ORD-2026-0891", account: "SM Supermarket - Makati", total: 48750.00, date: "03/05/2026", status: "delivered", timestamp: "10:30 AM" },
{ id: "ORD-2026-0892", account: "Robinsons Supermarket - QC", total: 32400.00, date: "03/06/2026", status: "shipped", timestamp: "02:15 PM" },
{ id: "ORD-2026-0893", account: "Puregold - Pasig", total: 19800.00, date: "03/06/2026", status: "processing", timestamp: "04:00 PM" },
{ id: "ORD-2026-0894", account: "Metro Gaisano - Cebu", total: 27600.00, date: "03/06/2026", status: "submitted", timestamp: "06:02 PM" }];


const LAST_ORDER_ITEMS = [
{ id: "p001", qty: 5 },
{ id: "p003", qty: 10 },
{ id: "p007", qty: 8 }];


const CATEGORIES = ["All", "Hair Care", "Body Care", "Oral Care", "Skin Care", "Household Care"];

export default function SalesOrderingSystem() {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [cartItems, setCartItems] = useState([]);
  const [formData, setFormData] = useState({ accountId: "", deliveryDate: "", deliveryAddress: "", specialInstructions: "" });
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [placedOrder, setPlacedOrder] = useState(null);
  const [lastSync, setLastSync] = useState("Today, 06:00 PM");
  const [mobileView, setMobileView] = useState("catalog");

  const ACCOUNT_NAMES = {
    "acc-001": "SM Supermarket - Makati",
    "acc-002": "Robinsons Supermarket - Quezon City",
    "acc-003": "Puregold - Pasig",
    "acc-004": "Metro Gaisano - Cebu City",
    "acc-005": "Landers Superstore - Alabang",
    "acc-006": "Walter Mart - Cavite",
    "acc-007": "Savemore Market - Davao",
    "acc-008": "Prince Hypermart - Iloilo"
  };

  const filteredProducts = useMemo(() => {
    return PRODUCTS?.filter((p) => {
      const matchesSearch = p?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) || p?.sku?.toLowerCase()?.includes(searchQuery?.toLowerCase());
      const matchesCategory = selectedCategory === "All" || p?.category === selectedCategory;
      return matchesSearch && matchesCategory;
    });
  }, [searchQuery, selectedCategory]);

  const cartQtyMap = useMemo(() => {
    const map = {};
    cartItems?.forEach((item) => {map[item.id] = item?.qty;});
    return map;
  }, [cartItems]);

  const addToCart = (product) => {
    setCartItems((prev) => {
      const existing = prev?.find((i) => i?.id === product?.id);
      if (existing) {
        return prev?.map((i) => i?.id === product?.id ? { ...i, qty: Math.min(i?.qty + 1, product?.stock) } : i);
      }
      return [...prev, { ...product, qty: 1 }];
    });
  };

  const updateQty = (id, qty) => {
    if (qty <= 0) {
      setCartItems((prev) => prev?.filter((i) => i?.id !== id));
    } else {
      setCartItems((prev) => prev?.map((i) => {
        if (i?.id !== id) return i;
        return { ...i, qty: Math.min(qty, i?.stock) };
      }));
    }
  };

  const removeFromCart = (id) => setCartItems((prev) => prev?.filter((i) => i?.id !== id));
  const clearCart = () => setCartItems([]);

  const handleFormChange = (field, value) => setFormData((prev) => ({ ...prev, [field]: value }));

  const handleRepeatLastOrder = () => {
    const items = LAST_ORDER_ITEMS?.map(({ id, qty }) => {
      const product = PRODUCTS?.find((p) => p?.id === id);
      return product ? { ...product, qty: Math.min(qty, product?.stock) } : null;
    })?.filter(Boolean);
    setCartItems(items);
  };

  const handlePlaceOrder = () => {
    const subtotal = cartItems?.reduce((sum, item) => sum + (item?.promoPrice || item?.price) * item?.qty, 0);
    const total = subtotal * 1.12;
    const order = {
      id: `ORD-2026-${String(Math.floor(Math.random() * 9000) + 1000)}`,
      account: ACCOUNT_NAMES?.[formData?.accountId] || "Unknown Account",
      itemCount: cartItems?.length,
      total,
      deliveryDate: formData?.deliveryDate || "TBD"
    };
    setPlacedOrder(order);
    setShowSuccessModal(true);
    setCartItems([]);
    setFormData({ accountId: "", deliveryDate: "", deliveryAddress: "", specialInstructions: "" });
  };

  const handleAction = (action) => {
    if (action === "new-order") clearCart();
    if (action === "bulk-import") setShowUploadModal(true);
    if (action === "export") alert("Exporting orders...");
  };

  const totalCartItems = cartItems?.reduce((sum, i) => sum + i?.qty, 0);

  return (
    <div className="min-h-screen bg-background page-gradient-bg">
      <TopNavigation />
      <NotificationAlertBar />
      <QuickActionToolbar onAction={handleAction} />
      <InventorySyncBar lastSync={lastSync} />
      {/* Page Header */}
      <div className="px-4 md:px-6 lg:px-8 py-4 md:py-5 border-b border-border bg-card">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <div>
            <h1 className="font-heading font-bold text-xl md:text-2xl text-foreground">Sales Ordering System</h1>
            <p className="font-caption text-sm text-muted-foreground mt-0.5">Process field orders and track fulfillment</p>
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            <Button variant="outline" size="sm" iconName="Upload" iconPosition="left" iconSize={15} onClick={() => setShowUploadModal(true)}>
              Upload Order
            </Button>
            <Button variant="outline" size="sm" iconName="FileText" iconPosition="left" iconSize={15}>
              Export PDF
            </Button>
          </div>
        </div>
      </div>
      {/* Mobile Tab Switcher */}
      <div className="lg:hidden flex border-b border-border bg-card sticky top-16 z-10">
        {[
        { key: "catalog", label: "Catalog", icon: "Grid3X3" },
        { key: "cart", label: `Cart (${totalCartItems})`, icon: "ShoppingCart" },
        { key: "orders", label: "Orders", icon: "Package" }]?.
        map((tab) =>
        <button
          key={tab?.key}
          onClick={() => setMobileView(tab?.key)}
          className={`flex-1 flex items-center justify-center gap-1.5 py-3 font-caption text-sm font-medium transition-colors border-b-2 ${mobileView === tab?.key ? "text-primary border-primary" : "text-muted-foreground border-transparent"}`}>
          
            <Icon name={tab?.icon} size={15} color="currentColor" strokeWidth={2} />
            {tab?.label}
          </button>
        )}
      </div>
      {/* Main Content */}
      <div className="px-4 md:px-6 lg:px-8 py-4 md:py-6">
        <div className="flex gap-6">
          {/* Left: Catalog + Order Form */}
          <div className={`flex-1 min-w-0 space-y-4 md:space-y-6 ${mobileView !== "catalog" && mobileView !== "orders" ? "hidden lg:block" : ""} ${mobileView === "orders" ? "block lg:block" : ""} ${mobileView === "catalog" ? "block" : "hidden lg:block"}`}>

            {/* Order Form */}
            <OrderForm formData={formData} onChange={handleFormChange} onRepeatLastOrder={handleRepeatLastOrder} />

            {/* Product Catalog */}
            <div className={`${mobileView === "orders" ? "hidden lg:block" : ""}`}>
              <div className="flex flex-col sm:flex-row gap-3 mb-4">
                <div className="flex-1">
                  <Input
                    type="search"
                    placeholder="Search products by name or SKU..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e?.target?.value)} />
                  
                </div>
                <div className="flex gap-2 overflow-x-auto pb-1 flex-shrink-0">
                  {CATEGORIES?.map((cat) =>
                  <button
                    key={cat}
                    onClick={() => setSelectedCategory(cat)}
                    className={`flex-shrink-0 px-3 py-1.5 rounded-full font-caption text-xs font-medium transition-colors ${selectedCategory === cat ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground hover:bg-border"}`}>
                    
                      {cat}
                    </button>
                  )}
                </div>
              </div>

              <div className="flex items-center justify-between mb-3">
                <h2 className="font-heading font-semibold text-base text-foreground">
                  Product Catalog
                  <span className="font-caption text-sm text-muted-foreground font-normal ml-2">({filteredProducts?.length} items)</span>
                </h2>
              </div>

              {filteredProducts?.length === 0 ?
              <div className="text-center py-12 bg-card rounded-lg border border-border">
                  <Icon name="Search" size={40} color="var(--color-muted-foreground)" strokeWidth={1.5} className="mx-auto mb-3" />
                  <p className="font-caption text-sm text-muted-foreground">No products found for &quot;{searchQuery}&quot;</p>
                </div> :

              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
                  {filteredProducts?.map((product) =>
                <ProductCard
                  key={product?.id}
                  product={product}
                  onAddToCart={addToCart}
                  cartQuantity={cartQtyMap?.[product?.id] || 0} />

                )}
                </div>
              }
            </div>

            {/* Order Tracker */}
            <div className={`${mobileView === "catalog" ? "hidden lg:block" : ""}`}>
              <OrderTracker orders={RECENT_ORDERS} />
            </div>
          </div>

          {/* Right: Cart Panel (Desktop) */}
          <div className={`w-80 xl:w-96 flex-shrink-0 ${mobileView === "cart" ? "block w-full" : "hidden lg:block"}`}>
            <div className="sticky top-24 card p-4 md:p-5" style={{ maxHeight: "calc(100vh - 200px)", display: "flex", flexDirection: "column" }}>
              <CartPanel
                cartItems={cartItems}
                onUpdateQty={updateQty}
                onRemove={removeFromCart}
                onClearCart={clearCart}
                onPlaceOrder={handlePlaceOrder}
                selectedAccount={formData?.accountId} />
              
            </div>
          </div>
        </div>
      </div>
      {/* Modals */}
      {showUploadModal &&
      <UploadOrderModal
        onClose={() => setShowUploadModal(false)}
        onUpload={(file) => console.log("Uploaded:", file?.name)} />

      }
      {showSuccessModal && placedOrder &&
      <OrderSuccessModal
        order={placedOrder}
        onClose={() => {setShowSuccessModal(false);setPlacedOrder(null);}}
        onExportPDF={() => alert("Generating PDF confirmation...")} />

      }
      {/* Mobile bottom padding */}
      <div className="h-16 lg:h-0" />
    </div>);

}